import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Stack,
  CircularProgress,
} from "@mui/material";
import { useClub } from "../club/ClubContext";
import { fetchPublicPenaltyTypes } from "../dataProvider/resources/penalties";

type PenaltyType = {
  id: number;
  name: string;
  description?: string | null;
  amount: number;
  active: boolean;
};

export default function PenaltyPublicPage() {
  const { clubId } = useClub();
  const [types, setTypes] = React.useState<PenaltyType[]>([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    if (!clubId) return;
    setLoading(true);
    fetchPublicPenaltyTypes(clubId)
      .then(setTypes)
      .catch(() => setTypes([]))
      .finally(() => setLoading(false));
  }, [clubId]);

  return (
    <Box p={2} maxWidth={600}>
      <Typography variant="h5" fontWeight={800} mb={2}>
        Strafenkatalog
      </Typography>

      {loading ? (
        <CircularProgress />
      ) : types.length === 0 ? (
        <Typography color="text.secondary">Kein Strafenkatalog verfügbar.</Typography>
      ) : (
        <Stack spacing={1}>
          {types.map((t) => (
            <Card key={t.id}>
              <CardContent sx={{ pb: "12px !important" }}>
                <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                  <Box flex={1} minWidth={0}>
                    <Typography fontWeight={600}>{t.name}</Typography>
                    {t.description && (
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
                        {t.description}
                      </Typography>
                    )}
                  </Box>
                  <Typography fontWeight={700} color="primary.main" sx={{ ml: 2, flexShrink: 0 }}>
                    € {Number(t.amount).toFixed(2).replace(".", ",")}
                  </Typography>
                </Stack>
              </CardContent>
            </Card>
          ))}
        </Stack>
      )}
    </Box>
  );
}
